import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const renderOptions = options => {
  const optArray = [];
  options.map(o => o.has_forecast && optArray.push({ value: o.state_id, label: o.state_name }));
  return optArray;
};

const Dropdown = ({ options, onChange, selectedStateId, selectedStateName }) => (
  <Select
    classNamePrefix="Select"
    classNames={{ container: () => "Select__container" }}
    onChange={e => onChange(e.value)}
    options={renderOptions(options)}
    placeholder="Select state"
    value={selectedStateName ? {label: selectedStateName, value: selectedStateId} : null}
    isSearchable={false}
    isClearable={false}
  />
);

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  onChange: PropTypes.func.isRequired,
  selectedStateId: PropTypes.string.isRequired,
  selectedStateName: PropTypes.string.isRequired,
};

export default Dropdown;
